import { Component, OnInit } from '@angular/core';
import { Asegurado } from '../Models/asegurado-detalle';
import { ApiService } from '../Services/api.services';
import { FormDataService } from '../Services/form-data.services';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  asegurado: Asegurado;

  constructor(
  ) {
  }

  ngOnInit(): void{
  }

}
